import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Container, Form, Image, Spinner } from "react-bootstrap";
import { MdDelete, MdOutlineCancel } from "react-icons/md";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { apiGetLocalisations } from "../../../api/ApiLocalisation";
import { apiGetMarques } from "../../../api/ApiMarque";
import { apiGetPersonne, apiUpdatePersonne } from "../../../api/ApiPersonnes";
import ComponentMenu from "../../../components/layout/ComponentMenu";
import ComponentTitle from "../../../components/layout/ComponentTitle";
import ModalCropImage from "../../../components/layout/ModalCropImage";
import ComponentRangeSlider from "../../../components/layout/ComponentRangeSlider";

let initialPersonne = {
  prenom: "",
  nom: "",
  email: "",
  telephone: "",
  dateEmbauche: "",
  urlCv: "",
  urlPortrait: "",
  localisations: [],
  marque: "",
  orgUnitsParent: [],
  lettresMbti: [],
};

const PageAdminUpdatePersonne = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [personne, setPersonne] = useState(initialPersonne);
  const [showModalCrop, setShowModalCrop] = useState(false);
  const [image, setImage] = useState("");
  const [localisations, setLocalisations] = useState([]);
  const [marques, setMarques] = useState([]);
  const [loader, setLoader] = useState(false);
  const [croppedImage, setCroppedImage] = useState("");
  const [showMbti, setShowMbti] = useState(false);
  const navigate = useNavigate();
  let { id } = useParams();

  useEffect(() => {
    recupLocalisations();
    recupMarques();
    recupPersonne();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const recupLocalisations = async () => {
    setLoader(true);
    const res = await apiGetLocalisations(ReduxInstance._id);
    if (res.data) {
      setLocalisations(res.data);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  const recupMarques = async () => {
    setLoader(true);
    const res = await apiGetMarques(ReduxInstance._id);
    if (res.data) {
      setMarques(res.data);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  const recupPersonne = async () => {
    setLoader(true);
    const res = await apiGetPersonne(ReduxInstance._id, id);
    if (res.data) {
      let personneCache = res.data;

      if (res.data.marque === null) {
        personneCache.marque = "";
      }
      let date = new Date(personneCache.dateEmbauche);
      personneCache.dateEmbauche =
        date.getFullYear() +
        "-" +
        (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) +
        "-" +
        (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
      if (personneCache.dateEmbauche === "1970-01-01") {
        personneCache.dateEmbauche = "";
      }

      if (personneCache.lettresMbti.length === 0) {
        personneCache.lettresMbti = [50, 50, 50, 50, 50];
      } else setShowMbti(true);

      setPersonne(personneCache);
      setLoader(false);
    } else {
      console.log("error");
      setLoader(false);
    }
  };

  const handleCheckLocalisation = (id) => {
    if (personne.localisations.includes(id)) {
      // Si le tiers-lieux est déja dans la liste c'est qu'on souhaite le retirer
      const newArrayWithRemovedPersonne = personne.localisations.filter((local) => {
        return local !== id;
      });
      setPersonne({ ...personne, localisations: newArrayWithRemovedPersonne });
    } else {
      setPersonne({
        ...personne,
        localisations: personne.localisations.concat(id),
      });
    }
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    const myForm = new FormData();
    Object.keys(personne).forEach((key) => {
      if (Array.isArray(personne[key])) {
        if (personne[key].length) {
          personne[key].forEach((element) => {
            myForm.append(key + "[]", element);
          });
        } else {
          myForm.append(key, null);
        }
      } else {
        myForm.append(key, personne[key]);
      }
    });
    if (image) {
      myForm.append("image", croppedImage);
    }
    if (!showMbti) {
      for (let key of myForm.keys()) {
        if (key === "lettresMbti[]") {
          myForm.delete(key);
          myForm.append("lettresMbti", null);
        }
      }
    }

    const res = await apiUpdatePersonne(personne._id, myForm);

    if (res) {
      navigate("/admin/easygouv/personnes");
    } else {
      console.log("error");
    }
  };

  const handleCloseCrop = () => {
    setShowModalCrop(false);
  };

  const emptyImage = () => {
    // On remet tout à plat.
    setImage("");
    setCroppedImage("");
    setPersonne({ ...personne, profilePic: "" });
    const inputFile = document.getElementById("formBasicImage");
    if (inputFile) {
      inputFile.value = "";
    }
  };

  const onSelectedFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setShowModalCrop(true);
    }
  };

  return (
    <>
      <ComponentMenu />
      <Container>
        <ComponentTitle title={t("admin.PageAdminCollaborateurs.modifier")} />
        {loader ? (
          <div style={{ justifyContent: "center", textAlign: "center" }}>
            <Spinner animation="grow" />
          </div>
        ) : (
          <Form onSubmit={onSubmit}>
            {personne.profilePic ? (
              <>
                <Image
                  width={168}
                  src={process.env.REACT_APP_URL_EXPRESS + "images/avatar/" + personne.profilePic}
                />
                <span role="button" onClick={() => emptyImage()}>
                  <MdDelete size="1.5em" />
                </span>
              </>
            ) : croppedImage ? (
              <div>
                <Image src={URL.createObjectURL(croppedImage)} width={164} height={200} />
                <span role="button" onClick={() => emptyImage()}>
                  <MdDelete size="1.5em" />
                </span>
              </div>
            ) : (
              <Form.Group className="mb-3" controlId="formBasicImage">
                <Form.Label>{t("commun.form.label.photo")}</Form.Label>
                <Form.Control type="file" onChange={onSelectedFile} />
              </Form.Group>
            )}
            <Form.Group className="mb-3" controlId="formBasicFirstname">
              <Form.Label>{t("commun.form.label.prenom")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("commun.form.placeholder.prenom")}
                value={personne.prenom}
                name="prenom"
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicLastname">
              <Form.Label>{t("commun.form.label.intitule1")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("commun.form.placeholder.intitule1")}
                name="nom"
                value={personne.nom}
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>{t("commun.form.label.email")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("commun.form.placeholder.email")}
                name="email"
                value={personne.email}
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPhone">
              <Form.Label>{t("commun.form.label.telephone")}</Form.Label>
              <Form.Control
                type="number"
                placeholder={t("commun.form.placeholder.telephone")}
                name="telephone"
                value={personne.telephone}
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formBasicDate">
              <Form.Label>
                {t("commun.form.label.dateEmbauche")}
                {personne.dateEmbauche && (
                  <MdOutlineCancel
                    size="1.5em"
                    role="button"
                    onClick={() => setPersonne({ ...personne, dateEmbauche: "" })}
                    className="ms-2 text-danger"
                  />
                )}
              </Form.Label>
              <Form.Control
                type="date"
                name="dateEmbauche"
                value={personne.dateEmbauche}
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicUrlCv">
              <Form.Label>{t("commun.form.label.cv")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("commun.form.placeholder.cv")}
                value={personne.urlCv}
                name="urlCv"
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicUrlPortrait">
              <Form.Label>{t("commun.form.label.portraitChinois")}</Form.Label>
              <Form.Control
                type="text"
                placeholder={t("commun.form.label.portraitChinois")}
                value={personne.urlPortrait}
                name="urlPortrait"
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label style={{ display: "flex" }}>
                <Form.Check
                  checked={showMbti}
                  type="checkbox"
                  style={{ marginRight: "5px" }}
                  onChange={(e) => setShowMbti(!showMbti)}
                />

                {t("commun.form.label.ProfilMbti")}
              </Form.Label>
              {showMbti ? (
                <>
                  <ComponentRangeSlider
                    percentage={personne.lettresMbti?.[0] ?? 50}
                    leftLabel={t("public.componentPersonne.profilMbtiExtraversion")}
                    rightLabel={t("public.componentPersonne.profilMbtiIntroversion")}
                    color="#4ECDC4"
                    isEditable={true}
                    onChange={(percent) => {
                      const newLettresMbti = [...personne.lettresMbti];
                      newLettresMbti[0] = Number(percent);
                      setPersonne({ ...personne, lettresMbti: newLettresMbti });
                    }}
                  />
                  <ComponentRangeSlider
                    percentage={personne.lettresMbti?.[1] ?? 50}
                    leftLabel={t("public.componentPersonne.profilMbtiSensation")}
                    rightLabel={t("public.componentPersonne.profilMbtiIntuition")}
                    color="#F7DC6F"
                    isEditable={true}
                    onChange={(percent) => {
                      const newLettresMbti = [...personne.lettresMbti];
                      newLettresMbti[1] = Number(percent);
                      setPersonne({ ...personne, lettresMbti: newLettresMbti });
                    }}
                  />
                  <ComponentRangeSlider
                    percentage={personne.lettresMbti?.[2] ?? 50}
                    leftLabel={t("public.componentPersonne.profilMbtiPensee")}
                    rightLabel={t("public.componentPersonne.profilMbtiSentiment")}
                    color="#7DCEA0"
                    name="lettreMbti3"
                    isEditable={true}
                    onChange={(percent) => {
                      const newLettresMbti = [...personne.lettresMbti];
                      newLettresMbti[2] = Number(percent);
                      setPersonne({ ...personne, lettresMbti: newLettresMbti });
                    }}
                  />
                  <ComponentRangeSlider
                    percentage={personne.lettresMbti?.[3] ?? 50}
                    leftLabel={t("public.componentPersonne.profilMbtiJugement")}
                    rightLabel={t("public.componentPersonne.profilMbtiPerception")}
                    color="#BB8FCE"
                    isEditable={true}
                    onChange={(percent) => {
                      const newLettresMbti = [...personne.lettresMbti];
                      newLettresMbti[3] = Number(percent);
                      setPersonne({ ...personne, lettresMbti: newLettresMbti });
                    }}
                  />
                  <ComponentRangeSlider
                    percentage={personne.lettresMbti?.[4] ?? 50}
                    leftLabel={t("public.componentPersonne.profilMbtiAssertif")}
                    rightLabel={t("public.componentPersonne.profilMbtiTurbulent")}
                    color="#F1948A"
                    isEditable={true}
                    onChange={(percent) => {
                      const newLettresMbti = [...personne.lettresMbti];
                      newLettresMbti[4] = Number(percent);
                      setPersonne({ ...personne, lettresMbti: newLettresMbti });
                    }}
                  />
                </>
              ) : (
                <div style={{ paddingLeft: "20px", fontSize: "10px" }}>
                  {t("commun.form.label.pasEncoreMBTI")}
                </div>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("commun.form.label.organisation")}</Form.Label>
              <Form.Select
                name="marque"
                value={personne.marque}
                onChange={(e) => setPersonne({ ...personne, [e.target.name]: e.target.value })}
              >
                <option value="">{t("commun.form.select.organisation")}</option>
                {marques.map((marque, index) => (
                  <option value={marque._id} key={"marque_" + index}>
                    {marque.nom}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t("commun.form.label.tiersLieux")}</Form.Label>
              {localisations.map((localisation) => (
                <Form.Check
                  key={localisation._id}
                  type="checkbox"
                  id={"localisation-" + localisation._id}
                  name="localisations"
                  label={localisation.nom}
                  checked={personne.localisations.includes(localisation._id)}
                  onChange={(e) => handleCheckLocalisation(localisation._id)}
                />
              ))}
            </Form.Group>

            <div className="justify-content-end d-flex">
              <Button
                variant="danger"
                type="button"
                className="me-2"
                onClick={() => navigate("/admin/easygouv/personnes/")}
              >
                {t("commun.form.button.annuler")}
              </Button>
              <Button variant="success" type="submit">
                {t("commun.form.button.modifier")}
              </Button>
            </div>
          </Form>
        )}

        <ModalCropImage
          show={showModalCrop}
          image={image}
          handleClose={handleCloseCrop}
          resetImage={emptyImage}
          setImageCropped={setCroppedImage}
          xRatio={84}
          yRatio={100}
        />
      </Container>
    </>
  );
};

export default PageAdminUpdatePersonne;
